import React,{useContext,useEffect, useState, useRef, useMemo, useCallback} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import ReactDOMServer from 'react-dom/server';
import { MultiSelect } from 'primereact/multiselect';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { navigationContextToQueryParams } from '../../utils/maintenanceNavigationContext';
import {
  applyUserMaskRowToTabulator,
  cleanSorters,
  safeParse,
  extractSafePaginationParams,
  createDedupedAjaxRequest,
  refreshProgressiveFromStart,
  mergePagedStandardListFiltersAndSorters,
  appendMaintenanceRecordDetailPagedFilter,
} from '../../utils/tabulatorProgressiveLoading';
import { showDeactivatedInLists, showExcludedMachinesInLists } from '../../utils/moduleSettings';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { getEffectiveMask } from '../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import {
  buildScheduledTreeAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
  scheduleExpandRemoteTreeRowsForActiveAuditFilter,
} from '../../utils/tabulatorAuditColumns';
import { useMaintenanceTypes } from '../../utils/useMaintenanceTypes';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
import { LocaleContext } from '../../components/LocaleContext';

const MASK_PAGE = 'MaintenanceRecordDetail';

const DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY = Object.freeze({
  id: true,
  custom_maintenance_type_name: true,
  custom_last_execution_date: true,
  custom_next_execution_date: true,
  custom_state: true,
  custom_deactivation_date: true,
  description: true,
  machine_part: true,
  required_attachment: true,
  protocol: true,
  scheduled_files: true,
  custom_company_name: true,
  custom_lecturer_name: true,
  custom_contact_name: true,
  'maintenance_type.type': true,
  'maintenance_type.norm': true,
  'maintenance_type.interval_months': true,
  'maintenance_type.responsible.name': true,
  'maintenance_type.description': true,
  created_at: true,
  updated_at: true,
});

function mergeMaintenanceRecordDetailColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY, saved);
}

function applyMaintenanceRecordDetailDataColumnVisibility(table, visibility) {
  if (!table) return;
  for (const field of Object.keys(DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceRecordDetail({machine, type, navigationContext}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,openFilePreview,getDateFormat,getUserColor,getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const { maintenanceTypes } = useMaintenanceTypes();

    const ref = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const auditTreeExpandInProgressRef = useRef(false);
    const auditTreeExpandScheduleRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const showDeactivated = showDeactivatedInLists(state.module_settings, 'maintenance');
    const showExcludedMachines = showExcludedMachinesInLists(state.module_settings);

    const pageSizePc = useMemo(() => {
        const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
        const n = parseInt(v, 10);
        return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY }));
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const effectiveCompanyContacts = (state.company_contacts || []).length ? (state.company_contacts || []) : companyContactsList;

    const [maintenanceCompanyContactsList, setMaintenanceCompanyContactsList] = useState([]);
    const effectiveMaintenanceCompanyContacts = (state.maintenance_company_contacts || []).length ? (state.maintenance_company_contacts || []) : maintenanceCompanyContactsList;

    useEffect(() => {
        if ((state.company_contacts || []).length > 0 && (state.maintenance_company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => {
                const list = Array.isArray(r?.data) ? r.data : (Array.isArray(r) ? r : []);
                setCompanyContactsList(list);
                setMaintenanceCompanyContactsList(list);
            })
            .catch(() => {});
    }, [state.company_contacts?.length, state.maintenance_company_contacts?.length]);

    const [formMachine, setFormMachine] = useState(machine);
    const currentMachineIdRef = useRef(machine?.id ?? null);
    const prevMachineIdRef = useRef(machine?.id);

    useEffect(() => {
        if (machine?.id != null) setFormMachine(machine);
    }, [machine?.id]);

    useEffect(() => {
        currentMachineIdRef.current = formMachine?.id ?? null;
    }, [formMachine?.id]);

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const scheduleAuditTreeExpand = useCallback(() => {
        if (isRestoringRef.current) return;
        scheduleExpandRemoteTreeRowsForActiveAuditFilter(getTable, auditTreeExpandInProgressRef, auditTreeExpandScheduleRef);
    }, [getTable]);

    useEffect(() => () => {
        if (auditTreeExpandScheduleRef.current != null) {
            clearTimeout(auditTreeExpandScheduleRef.current);
        }
    }, []);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                holder.scrollLeft = left;
                if (header) header.scrollLeft = left;
                savedHScrollRef.current.pending = false;
            });
        });
    }, [getTable]);

    const refreshMachineHeader = useCallback(() => {
        if (!formMachine?.id) return;
        getRequest(`/api/machine_cards/by_machine/${formMachine.id}`).then((r) => {
            const d = r?.data?.data ?? r?.data;
            if (d) setFormMachine(d);
        }).catch(() => {});
    }, [formMachine?.id]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (extra.size == null) extra.size = pageSizePc;
        extra.show_deactivated = showDeactivated ? '1' : '0';
        extra.show_excluded_machines = showExcludedMachines ? '1' : '0';
        const machineId = currentMachineIdRef.current;
        if (machineId != null) extra.filter_machine_id = String(machineId);
        mergePagedStandardListFiltersAndSorters(extra, {
            getTable,
            tableBuiltForParams: tableBuiltRef.current,
            userMaskFilters: state.user_mask_filters,
            maskPage: MASK_PAGE,
            appendFilter: appendMaintenanceRecordDetailPagedFilter,
        });
        return extra;
    }, [getTable, pageSizePc, showDeactivated, showExcludedMachines, state.user_mask_filters]);
    const canSetStandardMask = user?.permissions?.includes('set standard mask');
    const [maskVisible, setMaskVisible] = useState(false);

    //TODO dorobit contractor id
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);

    const [visibleRecord,setVisibleRecord] = useState(false);
    /** Druh technika: '' | 'external' | 'internal'. Pri úprave sa predvyplní z kontaktu, používateľ ho môže zmeniť a potom vybrať kontakt. */
    const [lecturerKind, setLecturerKind] = useState('');
    const [images,setImages] = useState('');
    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);
    /** maintenance_type_id pre formulár – z parent riadka stromu */
    const [selectedRecordMaintenanceTypeId, setSelectedRecordMaintenanceTypeId] = useState(null);

    const handleUpdateFileChange = (event) => {
        setUpdateFileList(event.target.files);
    };

    const onSelectRow = (data, rows) => {
        setDeleteIcon(true);
        setEditIcon(true);
        formikUpdate.resetForm();
        if(data.length>0){
            let children = 0;
            let parent = 0;
            data.forEach(obj => {
                if((obj?.machine_card_id ?? obj?.maintenance_scheduled_id) > 0){
                    children++;
                }
                else parent++;
            });
            if(children>0 && parent==0){
                if(user?.is_superuser || user.permissions?.includes("delete maintenance"))setDeleteIcon(false);
                if(data?.length==1 && (user?.is_superuser || user.permissions?.includes("edit maintenance"))){
                    const parentData = rows[0].getTreeParent()?.getData();
                    setSelectedRecord(data[0]);
                    setSelectedRecordMaintenanceTypeId(parentData?.maintenance_type_id ?? data[0]?.maintenance_type_id ?? null);
                    formikUpdate.setFieldValue("id",data[0]?.id);
                    formikUpdate.setFieldValue("maintenance_type_id",parentData?.maintenance_type_id ?? data[0]?.maintenance_type_id ?? "");
                    formikUpdate.setFieldValue("last_execution_date",data[0]?.last_execution_date);
                    formikUpdate.setFieldValue("description",data[0]?.description);
                    formikUpdate.setFieldValue("company_id",data[0]?.company_id);
                    const contactForRow = data[0]?.company_contact ?? effectiveCompanyContacts.find(c => String(c.id) === String(data[0]?.company_contact_id));
                    const kind = contactForRow?.employee_id != null ? 'internal' : 'external';
                    setLecturerKind(kind);
                    formikUpdate.setFieldValue("company_contact_id", data[0]?.company_contact?.id ?? data[0]?.company_contact_id ?? '');
                    setCompanyContacts(effectiveCompanyContacts.filter(contact => contact.company_id == data[0]?.company_id && (kind === 'internal' ? contact.employee_id != null : contact.employee_id == null)));
                    setEditIcon(false);
                }
            }
        }
    };

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    function changeCompany(company_id){
        setLecturerKind('');
        setCompanyContacts(effectiveCompanyContacts.filter(contact => contact.company_id == company_id));
        formikUpdate.setFieldValue('company_id',company_id);
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("machines",[]);
    }

    function changeLecturerKind(kind){
        setLecturerKind(kind);
        formikUpdate.setFieldValue('company_contact_id','');
        const cid = formikUpdate.values?.company_id;
        if (cid == null || cid === '') return;
        const list = effectiveCompanyContacts.filter(contact =>
            contact.company_id == cid && (kind === 'internal' ? contact.employee_id != null : kind === 'external' ? contact.employee_id == null : true)
        );
        setCompanyContacts(list);
    }

    function getRecordFiles(id){
        getRequest(`/api/maintenance_scheduled_records/protocols/${id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }

    useEffect(() => {
            // Update the document title using the browser API
        if(selectedRecord!=null){
            console.log(selectedRecord);
            console.log(formikUpdate.values);
            //getRecordFiles(selectedRecord.id);
        }
    },[selectedRecord]);

    const formikUpdate = useFormik({
        initialValues: selectedRecord ? 
            {id: selectedRecord?.id, maintenance_type_id: selectedRecordMaintenanceTypeId ?? selectedRecord?.maintenance_type_id ?? "",
            last_execution_date: selectedRecord?.last_execution_date, description: selectedRecord?.description,
            company_id: selectedRecord?.company_id ?? '', company_contact_id: selectedRecord?.company_contact?.id ?? selectedRecord?.company_contact_id ?? ''} : 
            {maintenance_type_id: '', last_execution_date: '', description: '', company_id: '', company_contact_id: ''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            for(let i = 0;i<updatefileList.length;i++){
                formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/maintenance_scheduled_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                refreshMachineHeader();
                refreshFromStart();
                setVisibleRecord(false);
                formikUpdate.resetForm();
                if(updatefileList.length){
                    setUpdateFileList([]);
                    updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    /** Pri otvorení dialógu úpravy doplníme kontakty pre zvolenú firmu a druh technika (aj keď sa načítali neskôr). */
    useEffect(() => {
        if (!visibleRecord) return;
        const cid = formikUpdate.values?.company_id;
        if (cid == null || cid === '') return;
        const list = effectiveCompanyContacts.filter(contact =>
            contact.company_id == cid && (lecturerKind === 'internal' ? contact.employee_id != null : lecturerKind === 'external' ? contact.employee_id == null : true)
        );
        setCompanyContacts(list);
    }, [visibleRecord, formikUpdate.values?.company_id, lecturerKind, effectiveCompanyContacts]);

    function hideEditRecord(){
        formikUpdate.resetForm();
        setLecturerKind('');
        setSelectedRecordMaintenanceTypeId(null);
        setVisibleRecord(false);
    }

    const resetDetailUiOnNavigate = useCallback(() => {
        setVisibleRecord(false);
        setSelectedRecord(null);
        setSelectedRecordMaintenanceTypeId(null);
        setLecturerKind('');
        setImages('');
        setUpdateFileList([]);
        if (updateFileListRef.current) updateFileListRef.current.value = null;
        setEditIcon(true);
        setDeleteIcon(true);
        formikUpdate.resetForm();
    }, [formikUpdate]);

    useEffect(() => {
        const prevId = prevMachineIdRef.current;
        const nextId = formMachine?.id;
        if (prevId === nextId) return;
        prevMachineIdRef.current = nextId;
        if (nextId == null || !tableBuiltRef.current) return;
        inFlightRef.current = { sig: null, promise: null };
        completedCacheRef.current.clear();
        captureHScroll();
        refreshFromStart();
    }, [formMachine?.id, captureHScroll, refreshFromStart]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const applyMachine = (data) => {
            if (!data) return;
            resetDetailUiOnNavigate();
            currentMachineIdRef.current = data.id ?? null;
            setFormMachine(data);
        };
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/machine_cards/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null || navigationContext?.extra != null) {
            const toParams = () => navigationContextToQueryParams(navigationContext);
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), applyMachine, () => currentMachineIdRef.current ?? formMachine?.id);
    }, [navigationContext, formMachine?.id, resetDetailUiOnNavigate, setDialogText, setVisible]);

    /** Otvorenie dialógu úpravy po kliku na ikonu úpravy v riadku (iba pre child záznamy a s oprávnením edit maintenance). */
    function startEditFromRow(row) {
        const rowData = row.getData();
        const cardId = rowData?.machine_card_id ?? rowData?.maintenance_scheduled_id;
        if (cardId == null || cardId === 0) return; // len child riadky
        const parentData = row.getTreeParent()?.getData();
        setSelectedRecord(rowData);
        setSelectedRecordMaintenanceTypeId(parentData?.maintenance_type_id ?? rowData?.maintenance_type_id ?? null);
        formikUpdate.setFieldValue("id", rowData?.id);
        formikUpdate.setFieldValue("maintenance_type_id", parentData?.maintenance_type_id ?? rowData?.maintenance_type_id ?? "");
        formikUpdate.setFieldValue("last_execution_date", rowData?.last_execution_date ?? "");
        formikUpdate.setFieldValue("description", rowData?.description ?? "");
        formikUpdate.setFieldValue("company_id", rowData?.company_id ?? "");
        const contactForRow = rowData?.company_contact ?? effectiveMaintenanceCompanyContacts.find(c => String(c.id) === String(rowData?.company_contact_id));
        const kind = contactForRow?.employee_id != null ? 'internal' : 'external';
        setLecturerKind(kind);
        formikUpdate.setFieldValue("company_contact_id", rowData?.company_contact?.id ?? rowData?.company_contact_id ?? '');
        setCompanyContacts(effectiveMaintenanceCompanyContacts.filter(contact => contact.company_id == rowData?.company_id && (kind === 'internal' ? contact.employee_id != null : contact.employee_id == null)));
        getRecordFiles(rowData?.id);
        setTimeout(() => setVisibleRecord(true), 0);
    }

    function MaintenanceTypeName(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.maintenance_type.name}</div>;
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotné vykonanie</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakované vykonanie</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.maintenance_type.name}</div>;
        }
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
    }
    
    function maintenanceHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(rowData?._children){
            if(headerValue!=""){
                return rowData.maintenance_type.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
            }
        }
        if(headerValue!=""){
                return rowData.maintenance_type.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }  

    function DeactivationDate(props) {
        const rowData = props.cell.getRow().getData();
        return rowData?.deactivation_date ? DateTime.fromISO(rowData.deactivation_date).toFormat(dateFmt) : "";
      }

      function LastExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.last_execution_date) return DateTime.fromISO(rowData.last_execution_date).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].last_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
      }

      function NextExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.next_execution_date) return DateTime.fromISO(rowData.next_execution_date).toFormat(dateFmt);
        if(rowData?._children.length > 0) return DateTime.fromISO(rowData._children[0].next_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
      }

    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(filterParams.name=="deactivation_date"){
            return DateTime.fromISO(rowData?.deactivation_date).toFormat(dateFmt).includes(headerValue);
        }
        if(rowData?._children?.length==0){
            if(headerValue!=""){
                if(new Date(rowData?.initial_date) > new Date())return t('Common.Scheduled').toLowerCase().includes(headerValue.toLowerCase());
                return t('Common.NotPerformed').toLowerCase().includes(headerValue.toLowerCase());
            }
        }
        if(filterParams.name=="last_execution_date"){
            return DateTime.fromISO(rowData?._children[0]?.last_execution_date).toFormat(dateFmt).includes(headerValue);
        }
        else if(filterParams.name=="next_execution_date"){
            return DateTime.fromISO(rowData?._children[0]?.next_execution_date).toFormat(dateFmt).includes(headerValue);
        }
    }

      function StateFormatter(props){
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data?._children;
            if(Array.isArray(parent_array)){
                for(let i = 0;i<parent_array.length;i++){
                    if(parent_array[i].id == rowData.id){
                        if(i==0){
                            if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                                return "DEA";
                            }
                            if(new Date(parent_array[i]?.next_execution_date) < new Date()){
                                return "NOK";
                            }
                            return "OK";
                        }
                        return "OK";
                    }
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="") return "DEA";
        if(rowData?._children?.length > 0){
            if(new Date(rowData._children[0]?.next_execution_date) < new Date()){
                return "NOK";
            }
            return "OK";
        }
        if(new Date(rowData?.initial_date) > new Date()){
            return "OK";
        }
        return "NOK";
      }

      function ZodpovednyFormatter(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardData = parent ? parent.getData() : rowData;
        const mt = cardData?.maintenance_type;
        if (mt?.use_central_responsible_person) {
          return <>{mt?.responsible?.name ?? ''}</>;
        }
        return <>{cardData?.responsible?.name ?? ''}</>;
      }

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(element => {
            deleteRequest(`/api/maintenance_scheduled_records/${element.id}`)
            .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
            }).catch((reason) => {
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
            });
        });
        refreshMachineHeader();
        refreshFromStart();
    }
        
        const reject = () => {
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };

    const acceptFile = (id) => {
        getRequest(`/api/maintenance_scheduled_records/deleteProtocol/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getRecordFiles(selectedRecord?.id);
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };

    function deleteFiles(img){
        confirmDialog({
            message: t('Common.ConfirmDeleteFile'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptFile(img.id)
        });
    }

    const normalizeText = (value) => (value || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = zobraz všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }

    const LECTURER_EXTERNAL = t('Common.ServiceCompanyEmployee');
    const LECTURER_INTERNAL = t('Common.InternalEmployee');

    function getLecturerLabelFromContact(companyContact) {
        if (!companyContact) return "";
        return companyContact?.employee_id != null ? LECTURER_INTERNAL : LECTURER_EXTERNAL;
    }

    function getLecturerLabelFromRow(rowData, allContacts = []) {
        // 1) preferuj eager-loaded objekt
        if (rowData?.company_contact) return getLecturerLabelFromContact(rowData.company_contact);
        // 2) fallback: ak máš iba company_contact_id, nájdi ho v store
        const id = rowData?.company_contact_id;
        if (!id) return "";
        const found = allContacts.find(c => String(c.id) === String(id));
        return getLecturerLabelFromContact(found);
    }

    function stateHeaderFilter(headerValue, rowValue, rowData){
        if (!headerValue || String(headerValue).trim() === "") return true;
        let state = "";
        if (rowData?.deactivation_date) state = "DEA";
        else if (rowData?._children?.length > 0) {
            state = new Date(rowData._children[0]?.next_execution_date) < new Date() ? "NOK" : "OK";
        } else if (new Date(rowData?.initial_date) > new Date()) {
            state = "OK";
        } else {
            state = "NOK";
        }
        const selected = new Set(String(headerValue).split(',').map(s => s.trim().toUpperCase()).filter(Boolean));
        if (selected.has("OK") && selected.has("NOK")) return true;
        return selected.has(state.toUpperCase());
    }
    function stavUkonuHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === "") return true;
        const label = (rowData?.deactivation_date != null && rowData?.deactivation_date !== "") ? t('Status.Deactivated') : "Aktívny";
        const selected = new Set(String(headerValue).split(',').map(s => s.trim()).filter(Boolean));
        return selected.has(label);
    }

    function viewFile(file_id){
        getRequest(`/api/maintenance_scheduled_records/protocol/${file_id}`).then((response) => {
            if (response?.data?.url) openFilePreview({ url: response.data.url, filename: response.data.filename });
        });
    }

    /** Otvorenie predlohy z karty stroja (MaintenanceScheduledFile) */
    function viewFileCard(file_id){
        getRequest(`/api/machine_cards/protocol/${file_id}`).then((response) => {
            const d = response?.data?.data ?? response?.data;
            if (d?.url) openFilePreview({ url: d.url, filename: d.filename });
        });
    }

    // Protokol = len MaintenanceScheduledRecordFile (súbory záznamu). Pri karte nikdy nepoužívať rowData.files – to sú predlohy (MaintenanceScheduledFile).
    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const isCardRow = rowData?._children !== undefined && Array.isArray(rowData._children);
        const recordFiles = isCardRow ? (rowData._children[0]?.files || []) : (rowData.files || []);
        const hasFiles = Array.isArray(recordFiles) && recordFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {recordFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFile(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    /** Predloha = súbory z karty stroja (MaintenanceScheduledFile) */
    function Predloha(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardFiles = parent ? (parent.getData()?.files || []) : (rowData?.files || []);
        const hasFiles = Array.isArray(cardFiles) && cardFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {cardFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFileCard(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    function RequiredAttachmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        // 0/1 môže prísť ako number aj string
        const raw = rowData?.required_attachment;
        const value = Number(raw) === 1 ? 1 : 0;
        return (
            <div className="w-full">
            {value === 1 ? t('Common.Yes') : t('Common.No')}
            </div>
        );
    }

    function CompanyName(props) {
        const rowData = props.cell.getRow().getData();
        /*if(rowData?._children?.length > 0){
            return rowData?._children[0]?.company?.name;
        }*/
        return rowData?.company?.name;
    }

    function companyHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if(headerValue!=""){
                return rowData?.company?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(headerValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
        }
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const label = getLecturerLabelFromRow(rowData, effectiveMaintenanceCompanyContacts);
        if (!label) return false; // keď nie je company_contact_id, nech to neprejde pri filtre
        return normalizeText(label).includes(normalizeText(headerValue));
    }

    function LecturerName(props) {
        const rowData = props.cell.getRow().getData();
        const label = getLecturerLabelFromRow(rowData, effectiveMaintenanceCompanyContacts);
        return label; // môže byť aj ""
    }

    function getCompanyContactFromRow(rowData) {
        if (rowData?.company_contact) return rowData.company_contact;
        const id = rowData?.company_contact_id;
        if (!id) return null;
        return effectiveMaintenanceCompanyContacts.find(c => String(c.id) === String(id)) || null;
    }

    function ContactName(props) {
        const rowData = props.cell.getRow().getData();
        const cc = getCompanyContactFromRow(rowData);
        if (!cc) return "";
        return cc.employee_id != null ? (cc?.employee?.name || "") : (cc?.name || "");        
    }

    function contactHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const cc = getCompanyContactFromRow(rowData);
        const name = cc?.employee?.name || cc?.name || "";
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const hasEditPermission = user?.permissions?.includes('edit maintenance');
        const isChildRow = (rowData?.machine_card_id ?? rowData?.maintenance_scheduled_id) != null && (rowData?.machine_card_id ?? rowData?.maintenance_scheduled_id) > 0;
        const canEdit = hasEditPermission && isChildRow;
        if (!canEdit) return null;
        return (
            <div className="flex items-center justify-center w-full h-full">
                <button type="button" className="p-1 border-0 cursor-pointer bg-transparent" onClick={(e) => { e.stopPropagation(); startEditFromRow(props.cell.getRow()); }} title={t('MaintenanceRecordDetail.Text.Upravit_zaznam')}>
                    <EditRowIcon />
                </button>
            </div>
        );
    }

    const dateFormatGlob = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const dateTimeFormatGlob = `${dateFormatGlob} HH:mm`;

    const auditColumns = useMemo(
      () =>
        buildScheduledTreeAuditTabulatorColumns({
          includeId: true,
          dateFormat: dateFormatGlob,
          dateTimeFormat: dateTimeFormatGlob,
          getUserColor,
          getUserInitials,
          textHeaderFilter,
        }),
      [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials, textHeaderFilter]
    );

    const idColumn = useMemo(() => auditColumns.find((c) => c.field === 'id'), [auditColumns]);
    const createdAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'created_at'), [auditColumns]);
    const updatedAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'updated_at'), [auditColumns]);

    const columns = useMemo(() => [
        { title: '', field: 'rowSelection', formatter:"rowSelection", titleFormatter:"rowSelection", titleFormatterParams:{rowRange:"active"}, hozAlign:"center", width: 44, headerSort:false, resizable:false, frozen: true, print: false, download: false,
            cellClick: function(e, cell) {
              cell.getRow().toggleSelect();
            }
        },
        { title: '', field: 'editor', hozAlign: 'center', width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false, frozen: true, print: false, download: false },
        idColumn,
        { title: t('Common.TaskName'), field: 'custom_maintenance_type_name',minWidth: 200,widthGrow:3,headerFilter:"input",headerFilterFunc:maintenanceHeaderFilter,formatter: reactFormatter(<MaintenanceTypeName/>),resizable:false},
        { title: t('Common.LastPerformed'), field: 'custom_last_execution_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"last_execution_date"},minWidth: 260,widthGrow:1,formatter: reactFormatter(<LastExecutionDate/>),resizable:false},
        { title: 'Nasled. vykonanie', field: 'custom_next_execution_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"next_execution_date"},minWidth: 210,widthGrow:1,formatter: reactFormatter(<NextExecutionDate/>),resizable:false},
        { title: 'Protokol', field: 'protocol',headerFilter:"input",minWidth: 200,formatter: reactFormatter(<Protocol/>)},
        { title: 'Predloha', field: 'scheduled_files', headerFilter:"input", minWidth: 200, formatter: reactFormatter(<Predloha/>)},
        { title: t('Common.Status'), field: 'custom_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Status'), options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: stateHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<StateFormatter/>), resizable: false },
        { title: t('Common.TaskStatus'), field: 'custom_deactivation_date', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.TaskStatus'), options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Status.Deactivated'), value: "Deaktivovaný" }] }, headerFilterFunc: stavUkonuHeaderFilter, minWidth: 180, widthGrow: 1, formatter: reactFormatter(<DeactivationDate/>), resizable: false },
        { title: t('Common.Description'), field: 'description',headerFilter:"input",minWidth: 200,widthGrow:2,resizable:false},
        { title: t('Common.MachinePart'), field: 'machine_part',headerFilter:"input",headerFilterFunc: textHeaderFilter,minWidth: 200,},
        {
            title: t('Common.RequiredAttachment'),
            field: 'required_attachment',
            minWidth: 200,
            formatter: reactFormatter(<RequiredAttachmentFormatter />),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.RequiredAttachment'), options: [{ label: t('Common.Yes'), value: '1' }, { label: t('Common.No'), value: '0' }] },
            headerFilterFunc: (headerValue, rowValue) => {
            if (headerValue === "" || headerValue == null || (Array.isArray(headerValue) && headerValue.length === 0)) return true;
            const rowVal = String(Number(rowValue) === 1 ? 1 : 0);
            const vals = Array.isArray(headerValue) ? headerValue : [headerValue];
            return vals.some(v => String(v) === rowVal);
            },
        },
        { title: 'Serv. firma', field: 'custom_company_name',headerFilter:"input",headerFilterFunc:companyHeaderFilter,minWidth: 200,formatter: reactFormatter(<CompanyName/>),},
        { title: 'Druh technika', field: 'custom_lecturer_name',headerFilter:"input", headerFilterFunc: lecturerHeaderFilter,minWidth: 200,formatter: reactFormatter(<LecturerName/>)},
        { title: t('Common.ContactPerson'), field: 'custom_contact_name',headerFilter:"input", headerFilterFunc: contactHeaderFilter,minWidth: 210,formatter: reactFormatter(<ContactName/>)},
        { title: t('Common.TaskType'), field: 'maintenance_type.type', headerFilter: "input", headerFilterFunc:textHeaderFilter, minWidth: 200 },
        { title: t('Common.Norm'), field: 'maintenance_type.norm', headerFilter: "input", headerFilterFunc:textHeaderFilter, minWidth: 200 },
        { title: t('Common.IntervalMonths'), field: 'maintenance_type.interval_months', headerFilter: "input", headerFilterFunc:textHeaderFilter, minWidth: 200 },
        { title: t('Common.ResponsibleShort'), field: 'maintenance_type.responsible.name', headerFilter: "input", headerFilterFunc:textHeaderFilter, minWidth: 180, formatter: reactFormatter(<ZodpovednyFormatter/>) },
        { title: t('Common.TaskDescription'), field: 'maintenance_type.description', headerFilter: "input", headerFilterFunc:textHeaderFilter, minWidth: 200 },
        createdAtColumn,
        updatedAtColumn,
    ].filter(Boolean), [idColumn, createdAtColumn, updatedAtColumn, textHeaderFilter]);

    const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
      const closeMenu = useCallback(() => {
        setTimeout(() => {
          OverflowMenuProvider.setVisible?.(null);
          setExpandedKeys({});
        }, 0);
      }, []);

      const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeMaintenanceRecordDetailColumnVisibilityFromSaved),
        [state.standard_mask_filters]
      );

      const openMaskDialog = useCallback(
        createOpenMaskDialog({
          columnsVisible,
          setColumnsVisible,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeMaintenanceRecordDetailColumnVisibilityFromSaved,
          setMaskVisible,
          closeMenu,
        }),
        [columnsVisible, closeMenu]
      );

      const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          setMaskVisible,
          toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
      );

      const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
          maskPage: MASK_PAGE,
          getTable,
          setStandardMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          toast,
        }),
        [getTable, setStandardMaskFilter, toast]
      );

      const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
          maskPage: MASK_PAGE,
          state,
          setUserMaskFilter,
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          mergeVisibilityFromSaved: mergeMaintenanceRecordDetailColumnVisibilityFromSaved,
          toast,
          closeMenu,
          onAppliedToTable: ({ colsForSave, attributes }) => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            try {
              table.setColumnLayout?.(attributes);
            } catch (_) {}
            setColumnsVisible(colsForSave);
            applyMaintenanceRecordDetailDataColumnVisibility(table, colsForSave);
            setTimeout(() => {
              isRestoringRef.current = false;
              table.redraw?.(true);
              captureHScroll();
              refreshFromStart();
            }, 0);
          },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast]
      );

      const setMask = useCallback(
        createMaskSetFieldHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          columnsVisible,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceRecordDetailDataColumnVisibility,
          toast,
        }),
        [columnsVisible, getTable, toast]
      );

      const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceRecordDetailDataColumnVisibility,
        }),
        [getTable]
      );

      const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
          defaultColumnVisibility: DEFAULT_MAINTENANCE_RECORD_DETAIL_COLUMN_VISIBILITY,
          setColumnsVisible,
          getTable,
          applyVisibilityToTable: applyMaintenanceRecordDetailDataColumnVisibility,
        }),
        [getTable]
      );
    
      const handleClickOutside = (event) => {
        if (event.target.closest('[data-overflow-trigger]')) return;
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
            OverflowMenuProvider.setVisible?.(null);
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      }
    ];

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            {user?.permissions?.includes('edit maintenance') && (
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => {getRecordFiles(selectedRecord?.id);setVisibleRecord(true);}} title={t('MaintenanceRecordDetail.Text.Upravit_zaznam')}><EditIcon/></button></div>
        )}
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { refreshMachineHeader(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('MaintenanceRecordDetail.Text.PLANOVANE_UKONY_STROJA'),"MaintenanceRecordDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("MaintenanceRecordDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          {canSetStandardMask ? (
            <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
              <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
                <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
              </button>
            </div>
          ) : null}
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={20} size={25}>
            <div className="w-full relative flex flex-col overflow-x">
              <div className='xl:grid grid-cols-2 gap-1 mb-2'>
              <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('MaintenanceRecordDetail.Text.PLANOVANE_UKONY_STROJA')}</h1>
                    <label className="block text-md font-semibold text-gray-800">Por.č.: {formMachine?.id}</label>
                    <div className="mt-6">
                        <div className="md:grid grid-cols-2 gap-2 mb-2">
                            <div>
                                <label
                                    htmlFor="name"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('Common.MachineName')}</label>
                                <input
                                    name='name'
                                    type="text"
                                    readOnly value={formMachine?.name}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="machine_type_id"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('MachineList.Column.MachineTypeName')}</label>
                                <select
                                    name='machine_type_id' disabled
                                    value={formMachine?.machine_type_id}
                                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                                    <option value="">{t('MachineAdd.SelectMachineType')}</option>
                                    {state.machine_types.map((machine_type) => (
                                    <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                                ))}
                                </select>
                            </div>
                            <div>
                                <label
                                    htmlFor="type"
                                    className="block text-md font-semibold text-gray-800"
                                >
                                    Typ stroja
                                </label>
                                <input
                                    name='type' readOnly
                                    type="text"
                                    value={formMachine?.type}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                            <div>
                                <label
                                    htmlFor="serial_number"
                                    className="block text-md font-semibold text-gray-800"
                                >{t('Common.SerialNumber')}</label>
                                <input
                                    name='serial_number' readOnly
                                    type="text"
                                    value={formMachine?.serial_number}
                                    className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                                />
                            </div>
                        </div>
                    </div>  
                </div>
                <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div className="md:grid grid-cols-2 gap-2 mb-2">
                        
                        <div>
                            <label
                                htmlFor="fabrication_year"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.FabricationYear')}</label>
                            <input
                                name='fabrication_year' readOnly
                                type="number"
                                value={formMachine?.fabrication_year}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="last_overhaul"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.LastOverhaul')}</label>
                            <input 
                                name='last_overhaul' readOnly
                                type="date"
                                value={formMachine?.last_overhaul}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="description"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Common.MachineDescription')}</label>
                            <textarea
                                name='description' readOnly
                                value={formMachine?.description}
                                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div> 
                        <div>
                        <label
                            htmlFor="manufacturer"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.Manufacturer')}</label>
                        <input
                            name='manufacturer' readOnly
                            type="text"
                            value={formMachine?.manufacturer}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    </div>
                </div>
                </div> 
                </div>
                 </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    {formMachine?.id != null && (
    <ReactTabulator
      onRef={(r) => (ref.current = r.current)}
      className='h-full w-full'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            const table = getTable();
            if (!table) return;
            isRestoringRef.current = true;
            const effective = getEffectiveMask(MASK_PAGE, state);
            if (effective?.type === 'user' && effective.userMask) {
              applyUserMaskRowToTabulator(table, effective.userMask, {
                setColumnsVisible,
                clearHeaderFiltersWhenEmpty: true,
                applyColumnVisibilityFn: (tbl, jc, setVis) => {
                  const merged = mergeMaintenanceRecordDetailColumnVisibilityFromSaved(jc);
                  setVis(merged);
                  applyMaintenanceRecordDetailDataColumnVisibility(tbl, merged);
                },
              });
            } else if (effective?.type === 'standard' && effective.standardMask) {
              const m = effective.standardMask;
              const attributes = safeParse(m.attributes, []);
              const jsonColumns = safeParse(m.columns, {});
              if (Array.isArray(attributes) && attributes.length > 1) {
                table.setColumnLayout?.(attributes);
              }
              if (jsonColumns && typeof jsonColumns === 'object') {
                const merged = mergeMaintenanceRecordDetailColumnVisibilityFromSaved(jsonColumns);
                setColumnsVisible(merged);
                applyMaintenanceRecordDetailDataColumnVisibility(table, merged);
              }
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
            tableBuiltRef.current = true;
            refreshFromStart();
          },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
        sortChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
        renderComplete: () => {
          restoreHScroll();
          scheduleAuditTreeExpand();
        },
      }}
        options={{
        layout: "fitColumns",
        renderHorizontal:"virtual",
        rowHeight:42,
        movableColumns: true,
        headerSortTristate: true,
        ajaxURL: "/api/maintenance_scheduled_records/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingEllipsis'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          scheduleAuditTreeExpand();
          return response;
        },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        dataTree:true,dataTreeStartExpanded:false,dataTreeFilter:false,dataTreeElementColumn: "custom_maintenance_type_name",
        dataTreeCollapseElement:ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement:ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement:ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        printAsHtml:true,printRowRange:"active",printCopyStyle:true,
        /*groupBy:"training.department.name",
        groupHeader:function(value, count, data, group){
            //value - the value all members of this group share
            //count - the number of rows in this group
            //data - an array of all the row data objects in this group
            //group - the group component for the group
            if(value=="----------")return "Všeobecné <span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
            return value + "<span style='color:#666; margin-left:10px;'>(" + count + ")</span>";
        },*/
        printHeader: function () {
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(
                <div className="w-full text-[11px]">
{/* 2. riadok – polia v dvoch stĺpcoch */}
                    <div className="grid grid-cols-2 gap-4 mb-2">
                        {/* Ľavý stĺpec */}
                        <div className="space-y-2">
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Ui.R67.Por_c')}</label>
                                <input
                                    type="text"
                                    readOnly
                                    value={formMachine?.id ?? ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
    
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineName')}</label>
                                <input
                                    name="name"
                                    type="text"
                                    readOnly
                                    value={formMachine?.name || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('MachineList.Column.MachineTypeName')}</label>
                                    <input
                                        name="machine_type_name"
                                        type="text"
                                        readOnly
                                        value={formMachine?.machine_type?.name || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">
                                        Typ stroja
                                    </label>
                                    <input
                                        name="type"
                                        type="text"
                                        readOnly
                                        value={formMachine?.type || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                            </div>
                        </div>
    
                        {/* Pravý stĺpec */}
                        <div className="space-y-2">
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.SerialNumber')}</label>
                                <input
                                    name="serial_number"
                                    type="text"
                                    readOnly
                                    value={formMachine?.serial_number || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
    
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.FabricationYear')}</label>
                                    <input
                                        name="fabrication_year"
                                        type="number"
                                        readOnly
                                        value={formMachine?.fabrication_year || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                                <div>
                                    <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.LastOverhaul')}</label>
                                    <input
                                        name="last_overhaul"
                                        type="date"
                                        readOnly
                                        value={formMachine?.last_overhaul || ''}
                                        className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                    />
                                </div>
                            </div>
    
                            <div>
                                <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.Manufacturer')}</label>
                                <input
                                    name="manufacturer"
                                    type="text"
                                    readOnly
                                    value={formMachine?.manufacturer || ''}
                                    className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                    </div>
    
                    {/* 3. riadok – popis cez celú šírku */}
                    <div className="mt-1">
                        <label className="block text-[11px] text-left font-semibold text-gray-800">{t('Common.MachineDescription')}</label>
                        <textarea
                            name="description"
                            readOnly
                            value={formMachine?.description || ''}
                            className="mt-1 block w-full px-2 text-[11px] bg-white border border-gray-300 rounded-md min-h-[40px]"
                        />
                    </div>
                </div>
            );
            return buildCanonicalPrintHeaderHtml({
                branding: state?.branding,
                productFallbackSrc: defaultProductLogoSrc,
                companySettingsPrint: state?.company_settings_print,
                moduleSettings: state?.module_settings,
                title: t('Print.Title.MaintenanceRecordDetail'),
                printDateLabel: t('Print.DateLabel'),
                bodyHtml,
            });
        },
                printFooter: function () {
                    return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
                }
      }}/>
    )}
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('MaintenanceRecordDetail.Text.Upravit_zaznam_udrzby')} visible={visibleRecord} style={{ width: '40vw' }} onHide={() => hideEditRecord()}>
            <form onSubmit={formikUpdate.handleSubmit}>
                    <div>
                        <label
                            htmlFor="maintenance_type_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Nazov_planovaneho_ukonu')}</label>
                        <select
                        name='maintenance_type_id'
                        disabled value={formikUpdate.values?.maintenance_type_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_ukon')}</option>
                        {maintenanceTypes.map(maintenance_type => (
                            <option key={maintenance_type.id} value={maintenance_type.id}>{maintenance_type.name}</option>
                        ))}
                        </select>
                    </div>   
                    <div>
                        <label
                            htmlFor="last_execution_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_vykonania')}</label>
                        <input
                            name='last_execution_date'
                            type="date"
                            required
                            onChange={formikUpdate.handleChange} value={formikUpdate.values?.last_execution_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>
                    <div>
                    <label
                        htmlFor="description"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.NoteUpper')}</label>
                    <input
                        name='description'
                        type="text"
                        onChange={formikUpdate.handleChange} value={formikUpdate.values?.description}
                        className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                    </div>
                    <div>
                        <label
                            htmlFor="company_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        Serv. firma
                        </label>
                        <select required
                        name='company_id'
                        onChange={(e) => changeCompany(e.target.value)} value={formikUpdate.values?.company_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_serv_firmu')}</option>
                        {state.maintenance_companies.map((maintenance_company) => (
                            <option key={maintenance_company.id} value={maintenance_company.id}>{maintenance_company.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formikUpdate.values?.company_id != "" && formikUpdate.values?.company_id != null) && <div>
                        <label htmlFor="lecturer_kind" className="block text-md font-semibold text-gray-800">Druh technika</label>
                        <select
                            id="lecturer_kind"
                            value={lecturerKind}
                            onChange={(e) => changeLecturerKind(e.target.value)}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('Ui.R67.Vyber_druh_technika')}</option>
                            <option value="external">Zamestnanec servisnej firmy</option>
                            <option value="internal">{t('Common.InternalEmployee')}</option>
                        </select>
                    </div>}
                    {(formikUpdate.values?.company_id != "" && formikUpdate.values?.company_id != null && lecturerKind !== "") && <div>
                        <label
                            htmlFor="company_contact_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.ContactPerson')}</label>
                        <select
                        name='company_contact_id'
                        onChange={formikUpdate.handleChange} value={String(formikUpdate.values?.company_contact_id ?? '')}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_kontaktnu_osobu')}</option>
                        {companyContacts.map((contact) => (
                            <option key={contact.id} value={String(contact.id)}>{contact?.employee?.name || contact?.name || ''}</option>
                        ))}
                        </select>
                    </div>}
                    {/* V dialógu len protokol (súbory záznamu); predloha sa tu nezobrazuje */}
                    <div>
                        <label
                            htmlFor="file"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Protokol
                        </label>
                        <input
                            name='files' 
                            ref={updateFileListRef}
                            onChange={handleUpdateFileChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='file'/>
                    </div> 
                    {images!=='' && images.map((img) => ( <div key={img.id} className='flex flex-row p-2'>
                        <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                            {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                            ) : (
                                <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                            )}
                        </div>
                            <div className='flex flex-col ml-4'>
                            <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                            <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                            </div>
                        </div>))}
                    <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </form>
            </Dialog>
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
        {columns.map((item) => {
          if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                    return <div 
                        key={item.field} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <MaintenanceMaskDialogCheckbox field={item.field} inputId={`mrd-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`mrd-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>
                    </div> 
                })} 
            <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</div>
            </> 
            );
} 
